<div class="form form--phone form--full-width" [ngClass]="getLevelClass()">
  <basic-label [noIndent]="true"></basic-label>
  <div class="form__container">
    <div class="form__field">
      <basic-text-input
        #phoneInput
        [propertyName]="questionItem.prop + '.number'"
        [placeholder]="isServer ? 'Phone number' : 'Phone'"
        [formatterType]="'telephone'"
        [parserType]="'Telephone'"
        [hideLabel]="true"
      ></basic-text-input>
    </div>
    <div class="form--phone__type">
      <label *ngIf="isServer" class="entry-field__label">Type:</label>
      <radio-group [property]="questionItem.prop + '.type'" [showTitle]="false" [noIndent]="true"></radio-group>
    </div>
  </div>
</div>
